import React from "react";
import { NavLink } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/delivery.scss";

export function PolicyLayout({ eyebrow = "Customer care", title, intro, children }) {
  return (
    <main className="policy-page">
      <header className="policy-page__header page-width">
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        {intro && <p>{intro}</p>}
      </header>
      <div className="policy-page__layout page-width">
        <nav aria-label="Customer care pages">
          <NavLink to="/shipping">Shipping</NavLink>
          <NavLink to="/returns">Returns &amp; exchanges</NavLink>
          <NavLink to="/privacy">Privacy</NavLink>
          <NavLink to="/terms">Terms</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>
        <article className="policy-page__content">{children}</article>
      </div>
    </main>
  );
}

function Delivery() {
  return (
    <PolicyLayout
      title="Shipping"
      intro="We pack orders carefully and keep the process straightforward from our workshop to your door."
    >
      <section>
        <span>01</span>
        <div>
          <h2>Domestic shipping</h2>
          <p>Standard ground shipping is free on U.S. orders of ${siteConfig.freeShippingThreshold} or more after discounts. Orders below that amount ship for ${siteConfig.shippingFlatRate}. Express service is available at checkout.</p>
          <p>Most domestic parcels arrive within 3–6 business days after dispatch. Remote locations may need a little longer.</p>
        </div>
      </section>
      <section>
        <span>02</span>
        <div>
          <h2>International shipping</h2>
          <p>We ship to most countries using tracked postal or courier services. Available methods and pricing appear after you enter your address at checkout.</p>
          <p>Import duties, taxes and local handling fees are set by the destination country and are the recipient’s responsibility.</p>
        </div>
      </section>
      <section>
        <span>03</span>
        <div>
          <h2>Processing and tracking</h2>
          <p>Orders typically leave within 1–2 business days. You will receive a shipping confirmation with tracking as soon as the parcel is collected.</p>
          <p>During releases and holiday periods, processing may take one additional business day.</p>
        </div>
      </section>
      <section>
        <span>04</span>
        <div>
          <h2>Address changes</h2>
          <p>Contact us as soon as possible if an address needs correcting. Once a parcel has entered the carrier network, we cannot guarantee that it can be rerouted.</p>
        </div>
      </section>
    </PolicyLayout>
  );
}

export default Delivery;
